import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { MsalService } from '.';
import * as Bixby from '$/core';
import { GraphService } from './GraphService';

export abstract class PeopleService extends GraphService {
  public static async search(searchTerm: string, showMnpiUsers: boolean): Promise<MicrosoftGraph.User[]> {
    const token: string | null = await MsalService.getPeopleSearchToken();

    if (!token || token.length <= 0) {
      throw new Error('Token not found');
    }

    let results: MicrosoftGraph.User[] = [];

    let plannerGroupId: string = Bixby.Configuration.plannerDataSiteGroupId;

    if(showMnpiUsers)
      plannerGroupId = Bixby.Configuration.plannerMnpiDataSiteGroupId;

    try {
      // Get Route
      let route = `/groups/${plannerGroupId}/members/microsoft.graph.user?$count=true&$select=displayName,id`;

      if (Bixby.Utils.isNullOrEmpty(searchTerm) === false) {
        route = `/groups/${plannerGroupId}/members/microsoft.graph.user?$count=true&$search="displayName:${searchTerm}"&$select=displayName,id`;
      }

      // Search for people
      const response: any = await PeopleService.get<MicrosoftGraph.User[]>(token, route);

      if (response && response.value && (response.value as []).length > 0) {
        // TODO - Graph is not searching on displayName
        results = (response.value as MicrosoftGraph.User[]).filter(
          x => x.displayName && x.displayName.toLowerCase().includes((searchTerm || '').toLowerCase())
        );
      }
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.log(error);
      // TODO - AppInsights
    }

    return results;
  }
}
